// extracted by mini-css-extract-plugin
module.exports = {"content":"VoteSnackbarContent_content__2rCdj","message":"VoteSnackbarContent_message__1_BTc","styledButton":"VoteSnackbarContent_styledButton__adxmK"};